"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateGS = exports.StateRunResultEnum = void 0;
const gs = require("../");
var StateRunResultEnum;
(function (StateRunResultEnum) {
    /**State successfull activated  */
    StateRunResultEnum[StateRunResultEnum["Activated"] = 0] = "Activated";
    /**State activation failed */
    StateRunResultEnum[StateRunResultEnum["Failed"] = 1] = "Failed";
    /**State activation failed, but instead of this state was activated another*/
    StateRunResultEnum[StateRunResultEnum["Skipped"] = 2] = "Skipped";
})(StateRunResultEnum = exports.StateRunResultEnum || (exports.StateRunResultEnum = {}));
class StateGS {
    constructor(title, inHistory = true) {
        this._urlArgs = {};
        this._active = false;
        if (!StateGS._Inited)
            StateGS._Initialize();
        this.title = title;
        this.inHistory = inHistory;
        this._active = false;
    }
    static _Initialize() {
        StateGS.UrlPathName = window.location.pathname.toLowerCase();
        StateGS.UrlFullPath = window.location.origin.toLowerCase() + StateGS.UrlPathName;
        window.onpopstate = (e) => StateGS.RunByUrl(e, false);
    }
    static Initialize(usePathRouting = false) {
        if (!StateGS._Inited)
            StateGS._Initialize();
        StateGS._UsePathRouting = usePathRouting;
        if (StateGS._UsePathRouting)
            StateGS.UrlStateArgName = "path0";
    }
    static Run(constructor, args, withHistory = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!constructor)
                return StateRunResultEnum.Failed;
            let state = constructor.Instance;
            if (!state)
                state = new constructor();
            state._name = constructor.StateName;
            return StateGS.RunInstance(state, args, withHistory);
        });
    }
    static RunInstance(state, args, withHistory = true) {
        return __awaiter(this, void 0, void 0, function* () {
            //Try activate new state
            const activeResult = yield state.start(args);
            if (activeResult !== StateRunResultEnum.Activated)
                return activeResult;
            //Set and show new state
            if (withHistory)
                if (state.inHistory) {
                    const stateStatus = {};
                    stateStatus[StateGS.UrlStateArgName] = state.name;
                    history.pushState(stateStatus, state.title, state.getUrlArgs());
                    //if (state.name.toLocaleLowerCase() !== StateGS.DefaultStateName.toLocaleLowerCase())
                    //else
                    //  history.pushState(stateStatus, state.title, StateGS.UrlPathName);
                }
            document.title = state.title;
            StateGS.CatchLinks();
            window.scrollTo(0, 0);
            yield state.afterStart(args);
            return StateRunResultEnum.Activated;
        });
    }
    static RunByUrl(e, withHistory = true) {
        return __awaiter(this, void 0, void 0, function* () { return yield StateGS.RunByUrlArgs(gs.web.getUrlArgs(), window.location.search, e, withHistory); });
    }
    static RunByUrlArgs(args, search, event, withHistory = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let stateName = args[StateGS.UrlStateArgName];
            if (!stateName)
                stateName = StateGS.DefaultStateName;
            let state = StateGS._RegStates.get(stateName.toLowerCase());
            if (!state) {
                state = StateGS._RegStates.get(StateGS.State404Name.toLowerCase());
                if (!state)
                    return StateRunResultEnum.Failed;
            }
            if (event)
                gs.events.stop(event);
            try {
                return yield StateGS.Run(state, args, withHistory);
            }
            catch (exc) {
                console.error(exc);
                return StateRunResultEnum.Failed;
            }
        });
    }
    static RegState(constructor) { this._RegStates.set(constructor.StateName.toLowerCase(), constructor); }
    static get ActiveState() { return StateGS._ActiveState; }
    overrideName(name) { this._name = name; }
    get name() { return this._name; }
    get title() { return this._title; }
    set title(value) { this._title = value; }
    get isActive() { return this._active; }
    stop() {
        return __awaiter(this, void 0, void 0, function* () { this._active = false; });
    }
    start(args) {
        return __awaiter(this, void 0, void 0, function* () {
            this._active = true;
            const wasState = StateGS._ActiveState;
            StateGS._ActiveState = this;
            if (wasState)
                yield wasState.stop();
            return StateRunResultEnum.Activated;
        });
    }
    afterStart(args) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
    updateUrl() {
        if (!this.inHistory)
            throw new Error("Can't update url. State not in history.");
        const stateStatus = {};
        stateStatus[StateGS.UrlStateArgName] = this.name;
        //   if (this.name.toLocaleLowerCase() !== StateGS.DefaultStateName.toLocaleLowerCase())
        history.pushState(stateStatus, this.title, this.getUrlArgs()); //else
        //  history.pushState(stateStatus, this.title, StateGS.UrlPathName);
    }
    getUrlArgs() {
        const pathParts = [];
        const queryParams = [];
        const pathUsed = new Set();
        let hasPath0 = false;
        if (StateGS._UsePathRouting)
            for (let i = 0;; i++) {
                const key = `path${i}`;
                if (!(key in this._urlArgs))
                    break;
                pathParts.push(this._urlArgs[key]);
                pathUsed.add(key);
                hasPath0 = true;
            }
        for (const key in this._urlArgs) {
            if (pathUsed.has(key))
                continue;
            queryParams.push(`${key}=${encodeURIComponent(this._urlArgs[key])}`);
        }
        if (StateGS._UsePathRouting) {
            if (!hasPath0 && StateGS.DefaultStateName != this.name)
                pathParts.push(encodeURIComponent(this.name));
            let queryString = "";
            let path = pathParts.join('/');
            if (queryParams.length > 0)
                queryString = `?${queryParams.join("&")}`;
            return `/${path}${queryString}`;
        }
        else {
            if (queryParams.length > 0)
                return `?${StateGS.UrlStateArgName}=${encodeURIComponent(this.name)}&${queryParams.join("&")}`;
            return `?${StateGS.UrlStateArgName}=${encodeURIComponent(this.name)}`;
        }
    }
    static CatchLinks() {
        document.querySelectorAll(`a:not(.${StateGS.LinkCatchedClassName})`).forEach(link => this._CatchLink(gs.w(link)));
    }
    static _CatchLink(wr) {
        const a = gs.def.toType(wr.el, HTMLAnchorElement);
        if (!a)
            return;
        wr.addClass(StateGS.LinkCatchedClassName);
        if (!a.href)
            return;
        wr.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
            if (!a.origin)
                return;
            if (a.origin != window.location.origin)
                return;
            if (!StateGS._UsePathRouting) {
                const fPath = a.origin.toLowerCase() + a.pathname.toLowerCase();
                if (fPath !== StateGS.UrlFullPath)
                    return;
            }
            const args = gs.web.parseUrlArgs(a.href);
            yield StateGS.RunByUrlArgs(args, a.search, e);
            gs.events.stop(e);
        });
    }
}
exports.StateGS = StateGS;
StateGS._Inited = false;
StateGS._RegStates = new Map();
StateGS.LinkCatchedClassName = "states-catched";
StateGS.UrlPathName = "";
StateGS.UrlFullPath = "";
StateGS.UrlStateArgName = "state";
StateGS.DefaultStateName = "main";
StateGS.State404Name = "";
StateGS._UsePathRouting = false;
//# sourceMappingURL=StateGS.js.map